import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function reportClientError(error, info) {
  try {
    const body = JSON.stringify({ message: String(error?.message || error).slice(0, 500), stack: String(error?.stack || "").slice(0, 2000),
      component_stack: String(info?.componentStack || "").slice(0, 2000), url: window.location.href, ua: navigator.userAgent.slice(0, 200) });
    if (navigator.sendBeacon) navigator.sendBeacon(`${API}/client-error`, new Blob([body], { type: "application/json" }));
    else fetch(`${API}/client-error`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
  } catch { /* ignore */ }
}

export class ErrorBoundary extends React.Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { reportClientError(error, info); }
  render() {
    if (!this.state.error) return this.props.children;
    const chunk = /Loading chunk|ChunkLoadError|Failed to fetch dynamically/i.test(String(this.state.error?.message));
    return (
      <div className="grid min-h-screen place-items-center bg-background px-5" data-testid="app-error-screen">
        <div className="glow-card max-w-md rounded-2xl p-8 text-center">
          <AlertTriangle className="mx-auto h-10 w-10 text-amber-300" />
          <h1 className="mt-4 font-display text-2xl font-bold text-white">Algo deu errado por aqui</h1>
          <p className="mt-2 text-sm text-slate-400">{chunk ? "O FlowIA foi atualizado enquanto esta página estava aberta." : "Já registramos o problema para corrigir."} Recarregue a página para continuar — nada foi perdido.</p>
          <button type="button" onClick={() => window.location.reload()} className="mt-6 inline-flex items-center gap-2 rounded-full bg-cyan-400 px-5 py-2 text-sm font-semibold text-slate-950 hover:bg-cyan-300" data-testid="app-error-reload">
            <RefreshCw className="h-4 w-4" /> Recarregar
          </button>
          <p className="mt-4 break-all font-mono-flow text-[10px] text-slate-600">{String(this.state.error?.message || "").slice(0, 160)}</p>
        </div>
      </div>
    );
  }
}
